import { ensureAllUserProjectsFetched } from '@modules/projects/stores/projects.thunks'
import { getCurrentWorkspace, getWorkspacesByUserId } from '@modules/workspaces/stores/workspaces.thunks'
import type { Workspace } from '@modules/workspaces/workspaces.type'

/**
 * After `getCurrentUser`, runs workspaces load, user-wide projects prefetch, and regional init in parallel.
 * Resolves the current workspace only after regional identity is available (for lastUsedWorkspaceId).
 */
export async function runInitialAppDataParallelBatch(
  initializeUserRegionalData: () => Promise<void>
): Promise<{ workspace: Workspace | null }> {
  const [, workspace] = await Promise.all([
    ensureAllUserProjectsFetched(),
    (async (): Promise<Workspace | null> => {
      await Promise.all([getWorkspacesByUserId(), initializeUserRegionalData()])
      return getCurrentWorkspace()
    })(),
  ])
  return { workspace }
}
